import Link from 'gatsby-link';
import React, { Component } from 'react';
import FaClose from 'react-icons/lib/fa/close';
import FaSearch from 'react-icons/lib/fa/search';
import {
    Configure,
    Highlight,
    Hits,
    InstantSearch,
    Pagination,
    SearchBox
} from 'react-instantsearch/dom';
import algoliaLogo from '../images/search-by-algolia.png';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
 // http://gorangajic.github.io/react-icons/fa.html

class QuickSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSearch: false
        }
    }

    render() {
        const Hit = ({ hit }) => (
            <Link to={`/${hit.slug}`} onClick={() => this.setState({ showSearch: false })}>
                <span className="hit-title">
                    <Highlight attribute="title" tagName="span" hit={hit} />
                </span>
            </Link>
        );
        return (
            <div className={ `top-search ${this.state.showSearch ? 'active' : ''}` }>
                <span id="top-search-button" className="top-search-button" 
                    onClick={() => {
                        this.setState({ showSearch: !this.state.showSearch });
                        // !this.state.showSearch && this.refs.searchInput.focus();
                    }}>
                    <FaSearch className={ `search-icon ${!this.state.showSearch ? '' : 'hidden'}` } />
                    <FaClose className={ `close-icon ${!this.state.showSearch ? 'hidden' : ''}` } />
                </span>
                        
                <InstantSearch 
                    appId="9DGKY76PYS"
                    apiKey="c5eda5ebf75e6738db41276f6f5b9d18"
                    indexName="dev.tonnguyen.com" >
                    <div className="search-form clear">
                        <Configure hitsPerPage={5} />
                        <SearchBox ref="searchInput" translations={{placeholder: 'Search ...'}} />
                        <div className="search-form__result">
                            <Hits hitComponent={Hit} />
                            <Pagination showFirst={false} padding={1} />
                            <OutboundLink href="https://www.algolia.com" target="_blank" rel="noopener">
                                <span className="algolia__logo">
                                    <img src={algoliaLogo} />
                                </span>
                            </OutboundLink>
                        </div>
                    </div>
                </InstantSearch>
            </div>
        );
    }
}

export default QuickSearch;


// WEBPACK FOOTER //
// ./src/components/QuickSearch.js